import { IMAGE_BANNER_SIZE_FIELDS } from "../../bannerSize";

// Fields, defaults, and library info for this section. The editor builds its form from `fields`.
const definition = {
  order: 30,
  type: "image_banner",
  name: "Banner",
  category: "Promotional",
  description: "A single image across the page. Upload a banner and shoppers see that picture.",
  defaultSettings: {
    imageUrl: "",
    mobileImageUrl: "",
    link: "",
    bannerHeight: "adapt",
    bannerHeightMobile: "same",
    bannerFit: "cover",
    bannerWidth: "full",
  },
  fields: [
    { key: "imageUrl", label: "Desktop image", type: "image" },
    {
      key: "mobileImageUrl",
      label: "Mobile image",
      type: "image",
      hint: "Optional. Phones use this photo. Leave it empty to keep the desktop image.",
    },
    { key: "link", label: "Link when the image is clicked", type: "text" },
    ...IMAGE_BANNER_SIZE_FIELDS,
  ],
};

export default definition;
